import { orange } from "./colors";

export const palette = {
  primary: {
    main: orange,
    contrastText: "white",
    dark: `#ec6608`,
    light: "#ffaa12",
  },
  secondary: {
    main: `#2484c6`,
  },
  error: {
    main: "#d32f2f",
  },
  background: {
    default: `#fff`,
  },
  text: {
    primary: "#2F2F2F",
    secondary: "#7d7d7d",
  },
};
